import LazyLoad from "vanilla-lazyload";

export default () => {
     const ll = new LazyLoad({
        elements_selector: ".lazy",
        threshold: -50
     });

 return ll;    
};